var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable complexity */
/* eslint-disable react/display-name */
import React, { forwardRef } from 'react';
import cx from 'classnames';
import GridItem from '../GridItem';
import * as S from './styles';
export var Grid = forwardRef(function Grid(_a, ref) {
    var alignItems = _a.alignItems, children = _a.children, direction = _a.direction, justifyContent = _a.justifyContent, spacing = _a.spacing, className = _a.className, style = _a.style, wrap = _a.wrap, rest = __rest(_a, ["alignItems", "children", "direction", "justifyContent", "spacing", "className", "style", "wrap"]);
    var spacingClassName = typeof spacing === 'string' && spacing + "-spacing";
    var alignItemsClassName = typeof alignItems === 'string' && alignItems + "-align-items";
    var justifyContentClassName = typeof justifyContent === 'string' && justifyContent + "-justify-content";
    var directionClassName = typeof direction === 'string' && direction + "-direction";
    var wrapClassName = typeof wrap === 'string' && wrap + "-wrap";
    var rootClass = cx(className, spacingClassName, alignItemsClassName, justifyContentClassName, directionClassName, wrapClassName);
    return (React.createElement(S.Grid, __assign({ className: rootClass, style: style, ref: ref }, rest), children));
});
Grid.defaultProps = {
    alignItems: 'flex-start',
    direction: 'row',
    justifyContent: 'flex-start',
    spacing: 'medium',
    wrap: 'wrap'
};
Grid.Item = GridItem;
Grid.displayName = 'Grid';
export default Grid;
//# sourceMappingURL=Grid.js.map